import React, { useState } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { withPrefix } from 'gatsby';

export default function ManagementTeam() {
  const [activeArea, setActiveArea] = useState(null);
  const people = [
    'Gita Gopinath',
    'Kenji Okamura',
    'Kristalina Georgieva',
    'Bo Li',
    'Antoinette Sayeh',
  ];

  const peopleTitle = [
    'First Deputy Managing Director',
    'Deputy Managing Director',
    'Managing Director',
    'Deputy Managing Director',
    'Deputy Managing Director',
  ];

  const mapArea = [
    {
      width: '14.44759206798867%',
      height: '67.14628297362111%',
      left: '2.9180683427761975%',
      top: '18.705035971222674%',
    },
    {
      width: '12.039660056657226%',
      height: '63.54916067146284%',
      left: '23.45631196883853%',
      top: '21.82254196642672%',
    },
    {
      width: '12.03966005665722%',
      height: '64.02877697841727%',
      left: '48.38549043909349%',
      top: '21.822541966426904%',
    },
    {
      width: '11.756373937677052%',
      height: '66.42685851318946%',
      left: '66.79908817280452%',
      top: '19.664268585131893%',
    },
    {
      width: '14.44759206798867%',
      height: '65.70743405275779%',
      left: '83.65461225212466%',
      top: '20.623501199041215%',
    },
  ];

  return (
    <Box as='figure' px={{ base: 30, xl: 60 }}>
      <Box position='relative' overflow='hidden'>
        {mapArea.map((area, index) => (
          <Box
            as='div'
            key={index}
            position='absolute'
            width={area.width}
            height={area.height}
            left={area.left}
            top={area.top}
            zIndex='1'
            onMouseOver={() => setActiveArea(index)}
            onMouseOut={() => setActiveArea(null)}
            aria-controls='person-info'
            cursor='pointer'
          />
        ))}
        <img src={`${withPrefix('/')}/management-team.jpg`} alt='Management Team' />
        <Box
          position='absolute'
          bottom='0'
          left='0'
          width='100%'
          padding={20}
          background='rgba(0,0,0,.5)'
          color='white'
          zIndex='2'
          textAlign='center'
          transform={activeArea !== null ? 'translateY(0)' : 'translateY(100%)'}
          transition='transform 0.25s ease-in'
          id='person-info'
          aria-live='polite'
        >
          <Text fontSize='md' fontWeight='600' textTransform='uppercase'>
            {people[activeArea] || ' '}
          </Text>
          <Text fontSize='sm' fontWeight='normal'>
            {peopleTitle[activeArea] || ' '}
          </Text>
        </Box>
      </Box>
      <Box my={10} as='figcaption'>
        <Text>
          From left to right: First Deputy Managing Director: GITA GOPINATH, Deputy Managing
          Director: KENJI OKAMURA, Managing Director: KRISTALINA GEORGIEVA, Deputy Managing
          Director: BO LI, Deputy Managing Director: ANTOINETTE SAYEH.
        </Text>
      </Box>
    </Box>
  );
}
